import BecaService from '@/entities/seguimiento/beca.service';
import AlertService from '@/shared/alert/alert.service';
import { FiltroBeca } from '@/shared/model/filtro.model';
import { BecaSeleccion, IBeca, IBecaSeleccion } from '@/shared/model/seguimiento/beca.model';
import { TipoSolucion } from '@conacyt/perfil-usuario-client';
import { Component, Emit, Inject, Prop, Vue } from 'vue-property-decorator';

/**
 */
@Component
export default class BuscadorBecarioComponent extends Vue {
  @Inject('alertService') private alertService!: () => AlertService;
  @Inject('becaService') private becaService!: () => BecaService;

  @Prop({
    required: false,
    default: false,
  })
  public esReadOnly!: boolean;

  @Prop({
    required: true,
  })
  public tipoSolucion!: TipoSolucion;

  @Prop({
    required: false,
    default: null,
  })
  public clavePrograma!: string;

  private consultandoBecas = false;

  public filtroCvuBecario: string | null = null;
  public becariosSeleccionados: Array<IBecaSeleccion> = [];

  public respuestaBeca: IBecaSeleccion | null = null;

  public consultarBecas(): void {
    this.consultandoBecas = true;
    this.respuestaBeca = null;
    this.becariosSeleccionados = [];
    if (this.filtroCvuBecario) {
      this.buscarBeca();
    } else {
      this.alertService().showInfo(this, this.$t('apeironGwApp.buscadorBecarios.mensajes.cvuRequerido').toString());
      this.consultandoBecas = false;
    }
  }

  private buscarBeca() {
    this.becaService()
      .findBecarioByCVU(this.filtroCvuBecario ?? '', this.clavePrograma)
      .then(res => {
        if (!res.data) {
          this.alertService().showInfo(this, this.$t('apeironGwApp.buscadorBecarios.mensajes.becarioNoEncontrado').toString());
          this.consultandoBecas = false;
          return;
        }
        this.respuestaBeca = new BecaSeleccion(false, res.data);
      })
      .catch(err => {
        if (!!err.response?.data?.detail) {
          this.alertService().showError(this, err.response.data.detail);
        } else {
          this.alertService().showHttpError(this, err.response);
        }
      })
      .finally(() => {
        this.consultandoBecas = false;
      });
  }

  @Emit('selected')
  public emitirSeleccion(): Array<IBeca> {
    if (this.respuestaBeca) {
      this.becariosSeleccionados.push(this.respuestaBeca);
    }
    return this.becariosSeleccionados.map(beca => beca.beca).filter(beca => !!beca) ?? [];
  }

  get consultandoElBack(): boolean {
    return this.consultandoBecas;
  }
}
